import React from "react";
import { Container, ContainerFluid } from "../components/Wrapper.js";
import Header from "../components/headers/Header.js";
import Footer from "../components/footers/Footer.js";
import Implement from "../components/Implemets.js";

export default function ImplemetPage(){
  return (
    <Container>
      <Header isActiveTab="3" />
      <ContainerFluid>
        <Implement />
      </ContainerFluid>
      <ContainerFluid>
        <Footer />
      </ContainerFluid>
    </Container>
  );
};